// @flow
import React, { memo } from 'react'
import classnames from 'classnames'

import Options from './Html5Select/Options'

import type { SelectItem } from '../SelectEnumRefIndex'

type Html5SelectProps = {
  error: Object,
  id: string,
  name: string,
  onUpdate: () => void,
  options: Array<SelectItem>,
  value: string,
}

const Html5Select = ({ error, id, name, onUpdate, options, value }: Html5SelectProps) => {
  const handleOnUpdate = (event: SyntheticInputEvent<HTMLInputElement>) => {
    if (event.target.value) {
      onUpdate(event.target.value)
    }
  }

  return (
    <div>
      <select
        className={getCssClasses(error)}
        data-hj-whitelist={true}
        id={id}
        name={name}
        onBlur={handleOnUpdate}
        onChange={handleOnUpdate}
        value={value}
      >
        <Options
          options={options}
          useDummyOption={true}
        />
      </select>

      {error}
    </div>
  )
}

export const getCssClasses = (error: Object): Array<string> => {
  const classes = ['form-control']

  if (!!error) {
    classes.push('is-invalid')
  }

  return classnames(classes)
}

export default memo(Html5Select)
